import React from 'react';
import './Security.css';

const Security = () => (
  <section className="section" id="security">
    <div className="security-inner">
      <div className="security-text reveal">
        <div className="eyebrow">Security First</div>
        <h2>Your money is safe.<br/>Full stop.</h2>
        <p>We built security into the foundation of SequPay, not bolted on as an afterthought. Every layer — from the chip on your phone to our servers — is protected by industry-leading standards.</p>
        <div className="security-pills">
          <div className="sec-pill"><span></span>256-bit AES Encryption</div>
          <div className="sec-pill"><span></span>TLS 1.3 in Transit</div>
          <div className="sec-pill"><span></span>Biometric Auth</div>
          <div className="sec-pill"><span></span>PIN Protected</div>
          <div className="sec-pill"><span></span>Zero Data Sold</div>
          <div className="sec-pill"><span></span>GDPR Aligned</div>
        </div>
      </div>
      <div className="security-cards reveal rd2">
        <div className="sec-card">
          <div className="sec-card-icon" style={{background:'rgba(37,99,235,.12)',color:'var(--trustBlue)'}}><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0 1 10 0v4"/></svg></div>
          <div><h4>End-to-End Encryption</h4><p>All data at rest uses 256-bit AES. All data in transit uses TLS 1.3 — no exceptions.</p></div>
        </div>
        <div className="sec-card">
          <div className="sec-card-icon" style={{background:'rgba(20,184,166,.1)',color:'var(--calmTeal)'}}><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/><polyline points="9 12 11 14 15 10"/></svg></div>
          <div><h4>Biometric &amp; 2FA</h4><p>Fingerprint, face ID, or PIN — layered with OTP-based two-factor authentication.</p></div>
        </div>
        <div className="sec-card">
          <div className="sec-card-icon" style={{background:'rgba(16,185,129,.1)',color:'var(--success)'}}><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg></div>
          <div><h4>Real-Time Fraud Detection</h4><p>Machine learning models analyse every transaction pattern to flag anomalies before they cause harm.</p></div>
        </div>
        <div className="sec-card">
          <div className="sec-card-icon" style={{background:'rgba(245,158,11,.1)',color:'var(--warning)'}}><svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg></div>
          <div><h4>Privacy by Design</h4><p>We collect only what we need. We never sell your personal data. You control your data — always.</p></div>
        </div>
      </div>
    </div>
  </section>
);

export default Security;
